"use strict";
var AsyncAction_1 = require('./AsyncAction');
var AsyncScheduler_1 = require('./AsyncScheduler');
exports.async = new AsyncScheduler_1.AsyncScheduler(AsyncAction_1.AsyncAction);
//# sourceMappingURL=async.js.map


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/rxjs/scheduler/async.js
// module id = 266
// module chunks = 1